export const CookieKeys = {
  REFRESH_TOKEN: {
    name: "VyFw7BBwXE",
    key: "%WVEE6Gv!mcN76J7SnA4vRCeX@Rft5",
  },
  HISTORY: {
    name: "FX934xTsxC",
    key: "0l7Bukj5xpxLd2KAsDukj5xTpxLwB!",
  },
};

export const LocalstorageKeys = {
  SPECIAL_SETTINGS_COCKPIT: {
    name: "2h0l7BFdXH",
    key: "%WVEE6Gv!mcN76J7SnA4vRCeX@Rft5",
  },
  SPECIAL_SETTINGS_CABIN: {
    name: "Dukj5xTpxL",
    key: "XrZsDukj5xTpxLukj5xpxLd2KAsgw33",
  },
};
